import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";


// Créer un compte 
export const CreateComment = (idSubject, titleSubject, content, typeactivite,coverPicture) => {
  var data = JSON.stringify({
    "titleSubject": titleSubject,
    "content": content,
    "idSubject": idSubject,
    "typeactivite": typeactivite,
    "image":coverPicture
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/comments/`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      alert("Commentaire enregistrer");
      //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
    });
}



// Recupérer tout compte des membres
export const LoadAllComment = (SetState, SetState2) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/comments/get/all`, {
    headers: { 
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    }
  })
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      SetState(response.data.data);
      SetState2(response.data.data);
    })
    .catch(function (error) {
      //console.log(error);
    });
}




// Recupérer tout compte des membres
export const LoadAllCommentSubjectId = async(id,SetState, SetState2) => {
  await axios.get(`${baseUrl.baseUrl}/api/v1/comments/subjectId/${id}`, {
    headers: { 
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    }
  })
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      SetState(response.data.data);
      SetState2(response.data.data);
    })
    .catch(function (error) {
      //console.log(error);
    });
}
